import * as React from "react";

const SvgShoppingcart = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M3 4h2l.4 2M7 14h10l4-8H5.4M7 14 5.4 6M7 14l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17M17 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
      <path d="M9 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
    </g>
  </svg>
);

export default SvgShoppingcart;
